import Joi from "joi-browser";
import { ASSISTANT } from "../Assistant";
import { voiceAssistant } from "../mock/voiceAssistant";

const fields = {
  name: {
    template: {
      name: "name",
      type: "text",
      label: "Agent Name",
    },
    schema: Joi.string().required().label("Agent Name"),
  },
  phoneNumber: {
    template: {
      name: "phoneNumber",
      type: "text",
      label: "Agent Phone Number",
    },
    schema: Joi.string().required(),
  },
  email: {
    template: {
      name: "email",
      type: "email",
      label: "Agent Email",
    },
    schema: Joi.string().email().allow(null, ""),
  },
  trigger: {
    template: {
      name: "trigger",
      type: "textArea",
      style: { height: "100px" },
      label: "Trigger",
    },
    schema: Joi.string().allow(null, ""),
  },
};

const whatsappAssistantFields = {
  name: fields.name,
  email: {
    ...fields.email,
    schema: Joi.string().email().required(),
  },
  phoneNumber: {
    ...fields.phoneNumber,
    schema: Joi.string().allow(null, ""),
  },
};

const instagramAssistantFields = {
  name: fields.name,
  email: {
    ...fields.email,
    schema: Joi.string().email().required(),
  },
  phoneNumber: {
    ...fields.phoneNumber,
    schema: Joi.string().allow(null, ""),
  },
};

const messengerAssistantFields = {
  name: fields.name,
  email: {
    ...fields.email,
    schema: Joi.string().email().required(),
  },
  phoneNumber: {
    ...fields.phoneNumber,
    schema: Joi.string().allow(null, ""),
  },
};

const voiceAssistantFields = {
  name: fields.name,
  phoneNumber: fields.phoneNumber,
  email: fields.email,
  slotTag: {
    template: {
      name: "slotTag",
      type: "select",
      label: "Slot Tag",
      options: [{ id: 0, value: "", label: "None" }],
    },
    schema: Joi.string().allow(null, ""),
  },
  trigger: fields.trigger,
};

const getTemplateAndSchema = (fields) => {
  return Object.keys(fields).reduce(
    (acc, field) => {
      const { template, schema } = acc;
      const fieldObj = fields[field];
      return {
        template: [...template, fieldObj.template],
        schema: {
          ...schema,
          [field]: fieldObj.schema,
        },
      };
    },
    { template: [], schema: {} }
  );
};

function getInputFields(settings, fields) {
  return Object.keys(fields).reduce((acc, field) => {
    return {
      ...acc,
      [field]: settings[field],
    };
  }, {});
}

function getTransferAgentByAssistant(assistantType, settings) {
  switch (assistantType) {
    case ASSISTANT.WHATSAPP:
      return {
        ...getTemplateAndSchema(whatsappAssistantFields),
        inputField: getInputFields(settings, whatsappAssistantFields),
      };
    case ASSISTANT.INSTAGRAM:
      return {
        ...getTemplateAndSchema(instagramAssistantFields),
        inputField: getInputFields(settings, instagramAssistantFields),
      };
    case ASSISTANT.MESSENGER:
      return {
        ...getTemplateAndSchema(messengerAssistantFields),
        inputField: getInputFields(settings, messengerAssistantFields),
      };
    case ASSISTANT.VOICE:
      return {
        ...getTemplateAndSchema(voiceAssistantFields),
        inputField: getInputFields(settings, voiceAssistantFields),
      };
    default:
      return {
        ...getTemplateAndSchema(fields),
        inputField: getInputFields(settings, fields),
      };
  }
}

export { getTransferAgentByAssistant };
